import Version from './version'
import VersionDetail from './detail'

export {
    Version,
    VersionDetail
}
